import { Component } from 'react';
import { withTranslation, useTranslation } from 'react-i18next';
import DateRangeFilter from 'components/Grid/Filter/DateRange';
import { dateTimeCell } from 'components/Grid/Cells/DateTimeCell';
import ListComponents from 'views/Orders/Orders/ListComponents';
import StatusPicker from 'views/Orders/Orders/StatusPicker';

import {
  paymentTypeOptions,
  paymentTypesTranslations,
} from '../../../Orders/Orders/columnConfig';

const translateSelectOptions = t => [
  t('paymentType.all'),
  t('common.paymentStatus.waiting'),
  t('common.paymentStatus.payed'),
  t('common.paymentStatus.cancelled'),
];

const v2types = [
  'OrderItemDayDish',
  'OrderItemDayAddon',
  'OrderItemDayDelivery',
  'OrderItemDayModification',
  'OrderItemDayDiet',
  'OrderItemDayMealType',
];

class RawValueFilter extends Component {
  state = {
    valueFrom: this.props.value?.valueFrom || null,
    valueTo: this.props.value?.valueTo || null,
  };

  render() {
    return (
      <div style={{ display: 'flex' }}>
        <input
          type="number"
          placeholder={this.props.t('clients.from')}
          value={this.state.valueFilter}
          onChange={async ev => {
            await this.setState({
              valueFrom: ev.target.value,
            });
            this.props.onFilterChange(this.state);
          }}
        />
        <input
          type="number"
          placeholder={this.props.t('clients.to')}
          value={this.state.valueFilter}
          onChange={async ev => {
            await this.setState({
              valueTo: ev.target.value,
            });
            this.props.onFilterChange(this.state);
          }}
        />
      </div>
    );
  }
}

const ValueFilter = withTranslation()(RawValueFilter);

const getColumnConfig = fillModal => [
  {
    title: 'ID',
    accessor: 'id',
    width: 100,
  },
  {
    title: 'clients.orderDate',
    Filter: ({ onChange, filter }) => (
      <DateRangeFilter onChange={onChange} value={filter?.value} />
    ),
    accessor: row => dateTimeCell(row.createdAt),
    name: 'createdAt',
    width: 300,
  },
  {
    title: 'orders.items',
    accessor: row => {
      if (row.items === undefined) {
        return null;
      }

      const orderItemDiets = row.items.filter(
        el => el.type === 'OrderItemDiet'
      );
      const v2Items = row.items.filter(el => v2types.includes(el.type));

      if (orderItemDiets.length > 0 && v2Items?.length > 0) {
        const Diet = ListComponents.OrderItemDiet;
        const V2Items = ListComponents.v2Types;

        return (
          <>
            {orderItemDiets

              .map(itemDiet => (
                <Diet orderId={row.id} item={itemDiet} key={itemDiet.id} />
              ))
              .reduce((prev, curr) => [prev, ', ', curr])}
            {', '}
            <V2Items items={v2Items} fillModal={fillModal} />
          </>
        );
      }

      if (v2Items?.length > 0) {
        const ComponentV2Types = ListComponents.v2Types;

        return <ComponentV2Types items={v2Items} fillModal={fillModal} />;
      }

      if (orderItemDiets.length > 0) {
        const ComponentOrderItemDiet = ListComponents.OrderItemDiet;

        return orderItemDiets

          .map(el => (
            <ComponentOrderItemDiet orderId={row.id} item={el} key={el.id} />
          ))
          .reduce((prev, curr) => [prev, ', ', curr]);
      }

      const diets = row.items.filter(el => el.type === 'DietItem');
      if (diets.length > 0) {
        const ComponentDietItem = ListComponents.DietItem;

        return diets
          .map(el => (
            <ComponentDietItem orderId={row.id} item={el} key={el.id} />
          ))
          .reduce((prev, curr) => [prev, ', ', curr]);
      }

      if (row.items.length === 0) {
        return null;
      }

      const ComponentOtherItem = ListComponents[row.items[0].type] || null;

      if (ComponentOtherItem === null) {
        return `Unknown type "${row.items[0].type}"`;
      }

      return (
        <ComponentOtherItem
          orderId={row.id}
          items={row.items}
          item={row.items[0]}
          userId={row.client.id}
        />
      );
    },
    name: 'dietName',
    width: 160,
    sortable: false,
  },
  {
    title: 'clients.orderValue',
    accessor: row => row.priceAfterDiscountWithoutMoneyBox.toFixed(2),
    name: 'priceAfterDiscountWithoutMoneyBox',
    sortable: false,
    width: 120,
    Filter: ({ onChange, filter }) => (
      <ValueFilter onFilterChange={onChange} value={filter?.value} />
    ),
  },
  {
    title: 'clients.status',
    accessor: row => (
      <StatusPicker
        value={row.status}
        disabled={row.status.systemValue === 'CANCELED'}
        orderId={row['@id']}
      />
    ),
    sortable: false,
    name: 'status.value',
    wrapFilter: true,
    Filter: ({ onChange, filter }, accessorPlug) => {
      const selectOptions = translateSelectOptions(accessorPlug.t);

      return (
        <select
          style={{ height: '30px', width: '100%', padding: '0' }}
          onChange={e => onChange(e.target.value)}
          value={filter?.value || ''}
        >
          <option value="">{selectOptions[0]}</option>
          <option value={selectOptions[1]}>{selectOptions[1]}</option>
          <option value={selectOptions[2]}>{selectOptions[2]}</option>
          <option value={selectOptions[3]}>{selectOptions[3]}</option>
        </select>
      );
    },
  },
  {
    title: 'clients.paymentType',
    accessor: (row, { t }) => t(paymentTypesTranslations[row.paymentType]),
    sortable: false,
    filterable: true,
    name: 'paymentType',
    wrapFilter: true,
    Filter: ({ onChange, filter }) => {
      const { t } = useTranslation();
      return (
        <select
          style={{ height: '30px', width: '100%', padding: '0' }}
          onChange={e => onChange(e.target.value)}
          value={filter?.value || ''}
        >
          <option value="">{t(paymentTypeOptions[0])}</option>
          {Object.entries(paymentTypesTranslations).map(([key, value]) => (
            <option key={key} value={key}>
              {t(value)}
            </option>
          ))}
        </select>
      );
    },
  },
];

export default getColumnConfig;
